import { render, staticRenderFns } from "./transferSelectionOperation.vue?vue&type=template&id=b4b223e8&scoped=true"
import script from "./transferSelectionOperation.vue?vue&type=script&lang=js"
export * from "./transferSelectionOperation.vue?vue&type=script&lang=js"
import style0 from "./transferSelectionOperation.vue?vue&type=style&index=0&id=b4b223e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b223e8",
  null
  
)

export default component.exports